<mat-card style="min-height: 700px">
    <mat-card-content [ngClass]="routeAnimationsElements">
        <div fxLayout="row" fxLayoutAlign="center">
            <div class="text-center pt-5">
                <h3>System Error</h3>
                <p>There was an error logging you into the system or you do not have permission to view the page.</p>
            </div>
        </div>
    </mat-card-content>
</mat-card>